var map = {
	"./bold.svg": "ff26",
	"./format-clear.svg": "adc2",
	"./h1.svg": "ebfb",
	"./h2.svg": "9d38",
	"./h3.svg": "c9fa",
	"./italic.svg": "9944",
	"./link.svg": "40a1",
	"./paragraph.svg": "bb80",
	"./strikethrough.svg": "090d",
	"./ul.svg": "6775",
	"./unlink.svg": "73a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";